(() => {
  // Easy proof it loaded
  window.HP_BOOKING_COPY_LOADED = true;

  const HIDE_EXACT = new Set([
    "Pick Date Not available",
    "%% errorMessage %%",
    "Sale Not available",
  ]);

  const SLOT_HEADING = "Pick a slot to continue";
  const HELPER_TEXT = "Select dates to check availability.";

  const norm = (s) => (s || "").replace(/\s+/g, " ").trim();

  function hideBadLines(root = document.body) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let n;
    while ((n = walker.nextNode())) {
      const t = norm(n.nodeValue);
      if (HIDE_EXACT.has(t) && n.parentElement) {
        n.parentElement.style.display = "none";
      }
    }
  }

//   function injectHelperText(root = document.body) {
//     const all = root.querySelectorAll("*");
//     for (const el of all) {
//       if (!el || el.children.length) continue;
//       if (norm(el.textContent) !== SLOT_HEADING) continue;

//       // Avoid duplicates
//       if (el.parentElement && el.parentElement.querySelector(".hp-booking-helper")) return;

//       const div = document.createElement("div");
//       div.className = "hp-booking-helper";
//       div.textContent = HELPER_TEXT;
//       div.style.marginTop = "6px";
//       div.style.opacity = "0.85";

//       el.insertAdjacentElement("afterend", div);
//       return;
//     }
//   }

  function run(root) {
    hideBadLines(root);
    // injectHelperText(root);
  }

  function init() {
    run(document.body);

    // Shipturtle may render after load, so watch and re-apply
    const obs = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1) run(node);
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
